import { AppPermissionScope, PersonaType } from '@bechtel/types';
import { CustomAuthScope } from './types';
import { useEnvProvider, ProjectAppTypes } from '@bechtel/client-common';
import { startCase, toUpper } from 'lodash';

export const nonePermissionScope: AppPermissionScope = {
  id: CustomAuthScope.NONE,
  name: 'None',
};

export const multiplePermissionScope: AppPermissionScope = {
  id: CustomAuthScope.MULTIPLE,
  name: 'Multiple',
};
export function useDefaultProjectRoles() {
  const { envConfig } = useEnvProvider();
  return [
    toUpper(startCase(PersonaType.FOREMAN)),
    toUpper(startCase(PersonaType.GENERAL_FOREMAN)),
    toUpper(startCase(PersonaType.SUPERINTENDENT)),
    toUpper(
      startCase(
        envConfig?.appName === ProjectAppTypes.PF ? PersonaType.FIELD_ENGINEER : PersonaType.FIELD_WELD_ENGINEER
      )
    ),
  ];
}
